/**
 * 用户 @user
 * -认证图片 @certificate
 *
 */
export default {
  userCertifyName: "user/certificate/real_name", // 实名认证
  userCertifyBase: "user/certificate/base", // 基础认证
  userCertifyProfession: "user/certificate/profession", // 职业认证
  userCertifyPlatform: "user/certificate/platform_certificate", // 平台证书

  tradeOrderCase: "trade/order/case", // 工作室发单 【order】
  workPortrait: "workstation/portrait" // 申请工作室头像
};
